import type { AlertSeverity } from "@/lib/types/alerts";
import type {
  Reminder,
  CreateReminderInput,
  ReminderPriority,
} from "@/hooks/use-reminders";
import { createReminder } from "@/lib/api/reminders";

const SEVERITY_TO_PRIORITY: Record<AlertSeverity, ReminderPriority> = {
  critical: "urgent",
  high: "urgent",
  medium: "standard",
  low: "standard",
};

export function mapAlertSeverityToPriority(
  severity: AlertSeverity
): ReminderPriority {
  return SEVERITY_TO_PRIORITY[severity];
}

export async function createReminderApi(
  input: CreateReminderInput
): Promise<Reminder | null> {
  try {
    const data = (await createReminder(input)) as { data: Reminder };
    return data.data;
  } catch {
    return null;
  }
}
